import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { StatusBadge } from './StatusBadge';
import { fadeUp } from '../../utils/motion';
type RelatedInitiativeProps = {
  name: string;
  body: string;
  href: string;
  status: string;
};
export function RelatedInitiative({
  name,
  body,
  href,
  status
}: RelatedInitiativeProps) {
  return <section aria-label="Related initiative" className="bg-surface-bg border-t border-line py-14 lg:py-16" data-id="element-671" data-mp="1bfbipsbssap4">
      <motion.div {...fadeUp} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-16 items-center" data-id="element-672" data-mp="1lfu4wtqu43a7">
        <div className="lg:col-span-5" data-id="element-673" data-mp="1q7c6nk0om7w8">
          <p className="text-sm font-medium text-teal mb-2" data-id="element-674" data-mp="1v5doy2qaa36n">Related Initiative</p>
          <div className="flex flex-wrap items-center gap-3" data-id="element-675" data-mp="1z78s7crryqn2">
            <h2 className="font-heading font-bold text-2xl lg:text-3xl text-ink-dark tracking-tight" data-id="element-676" data-mp="1z8tn53i04blg">{name}</h2>
            <StatusBadge data-id="element-677" data-mp="246lgm1yao5rr">{status}</StatusBadge>
          </div>
        </div>
        <div className="lg:col-span-7 flex flex-col sm:flex-row sm:items-center gap-5 sm:gap-10" data-id="element-678" data-mp="1cthvwg91dhyb">
          <p className="text-lg text-ink-dark leading-relaxed" data-id="element-679" data-mp="18qbv3o4p0iz8">{body}</p>
          <a href={href} className="shrink-0 inline-flex items-center gap-2 font-semibold text-navy hover:text-navy-light transition-colors duration-150 whitespace-nowrap rounded-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal" data-id="element-680" data-mp="13rihlvpeorz2">
            Explore {name}
            <ArrowRight size={16} aria-hidden="true" data-id="element-681" data-mp="1rjpin862tn4t" />
          </a>
        </div>
      </motion.div>
    </section>;
}